export default __webpack_public_path__ + "static/media/man-on-keyboard-small.1e4c646a.png";